import { useCallback, useMemo } from "react";
import { routes } from "@/router";
import { platformMapper } from "@/utils/crm.util";
import { useTranslation } from "react-i18next";
import { HiOutlineX } from "react-icons/hi";
import { HiOutlineArrowRight } from "react-icons/hi2";
import { useNavigate, useSearchParams } from "react-router-dom";

import Button from "@/components/atoms/Button";
import Spinner from "@/components/atoms/Spinner";
import FeaturedText from "@/components/molecules/FeaturedText";

const CRMErrorPage = () => {
  const { t } = useTranslation();
  const [queryParams] = useSearchParams();
  const navigate = useNavigate();
  const platform = useMemo(() => platformMapper(queryParams.get("platform"))?.toString(), [queryParams]);

  const confirm = useCallback(() => {
    navigate(routes.crm);
  }, [navigate]);

  if (!platform) {
    return (
      <div className={"flex flex-grow flex-col items-center justify-center gap-3"}>
        <Spinner size={"lg"} />
        <div className={"grid max-w-80 justify-center gap-2 text-center"}>
          <h2 className="text-xl font-semibold text-primary">{t("crm.connections.error.title")}</h2>
          <p className="break-words text-sm text-tertiary">{t("crm.connections.error.description")}</p>
        </div>
      </div>
    );
  }

  return (
    <FeaturedText
      featuredIcon={{ icon: HiOutlineX, color: "error", size: "xl" }}
      heading={t("crm.connections.error.title")}
      body={t("crm.connections.error.description", { platform })}
    >
      <div className={"pt-3"}>
        <Button
          label={t("crm.connections.error.button")}
          onClick={() => confirm()}
          trailingIcon={<HiOutlineArrowRight className={"size-5"} />}
        />
      </div>
    </FeaturedText>
  );
};

export default CRMErrorPage;
